import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider, withNamespaces } from 'react-i18next';
import { Provider } from 'react-redux';
import { SSENSEThemeProvider } from '@ssense/ui-component-library/lib/styles/SSENSEThemeProvider';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import i18n from './i18n';
import configureStore from './configureStore';
import AppContainer from './views/AppContainer';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
    };
  }

  componentDidMount = () => {
    const { initialized } = this.state;
    if (!initialized) {
      i18n.changeLanguage(localStorage.getItem('language') || 'en');
      this.setState({initialized: true});
    }
  };

  render() {
    const store = configureStore();
    return (
      <SSENSEThemeProvider>
        <Provider store={store}>
          <BrowserRouter>
            <I18nextProvider i18n={i18n}>
              <AppContainer />
            </I18nextProvider>
          </BrowserRouter>
        </Provider>
      </SSENSEThemeProvider>
    );
  }
}

export default withLDProvider({
  // will default to '' in development
  clientSideID: window.config.launchDarklyClientSideId,
  // flags are created through LaunchDarkly UI
  flags: window.config.flags
})(withNamespaces()(App));
